export const noop = () => {};

export const noRender = () => null;

export const noOffset = () => 0;
